import React from 'react';
import TopNav from '../components/Layout/TopNav.jsx';
import SplitPanel from '../components/Layout/SplitPanel.jsx';
import FilterBar from '../components/Layout/FilterBar.jsx';
import WatchlistPanel from '../components/Watchlist/WatchlistPanel.jsx';
import TickerDetails from '../components/Details/TickerDetails.jsx';
import useWatchlist from '../hooks/useWatchlist.js';

function MultiStrategySignals() {
  const { refresh } = useWatchlist();

  const leftPanel = (
    <>
      <FilterBar />
      <WatchlistPanel />
    </>
  );

  const rightPanel = (
    <TickerDetails />
  );

  return (
    <div className="app">
      <TopNav onRefresh={refresh} />
      <SplitPanel left={leftPanel} right={rightPanel} />
    </div>
  );
}

export default MultiStrategySignals;
